import { InstallParameters, Packet } from './index';
import { QueuedAttempts } from '@/app/tools/QueuedAttempts';
import { iMetricsSender } from '@/app/modules/Metrics/types';

export default class Loader implements iMetricsSender {
    /**
     * Делаем 20 попыток загрузки, каждые 100 мс
     */
    protected readonly AttemptsManager = new QueuedAttempts<Packet>(
        30,
        150,
        '1DMP'
    );

    /**
     * Установка сервиса
     *
     * @param bootstrap_parameters
     */
    public bootstrap(bootstrap_parameters: InstallParameters): Promise<void> {
        // Эти пакеты должны быть отправлены в первую очередь
        if (bootstrap_parameters.first_packets instanceof Array) {
            bootstrap_parameters.first_packets.forEach((packet: Packet) => {
                this.AttemptsManager.addToQueue(packet);
            });
        }

        return this.AttemptsManager.makeLoop(
            () => window.dmpkitdl && typeof window.dmpkitdl.push === 'function'
        ).then(() => {
            this.AttemptsManager.getQueue().forEach((packet) =>
                this.send(packet)
            );
        });
    }

    /**
     * Отправляем
     *
     * @param packet
     */
    public send(packet: Packet) {
        if (this.AttemptsManager.getIsInstalled()) {
            window.dmpkitdl.push(packet);
        } else {
            this.AttemptsManager.addToQueue(packet);
        }
    }
}
